import { render, staticRenderFns } from "./MarketplaceDialog.vue?vue&type=template&id=4cf1dc5c"
import script from "./MarketplaceDialog.vue?vue&type=script&lang=js"
export * from "./MarketplaceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports